/**
 * 动态加载高德地图 API
 * @returns {Promise} 返回 Promise，加载成功后 resolve
 */
export function loadAmapScript() {
  // 如果已经加载，直接返回
  if (typeof window.AMap !== 'undefined') {
    return Promise.resolve(window.AMap)
  }

  // 如果正在加载，返回现有的 Promise
  if (window.__amapLoadingPromise) {
    return window.__amapLoadingPromise
  }

  // 创建新的加载 Promise
  window.__amapLoadingPromise = new Promise((resolve, reject) => {
    if (!window.__canvasContextPatched) {
      const originalGetContext = HTMLCanvasElement.prototype.getContext
      HTMLCanvasElement.prototype.getContext = function(contextType, ...args) {
        if (contextType === '2d' && (!args[0] || typeof args[0] !== 'object' || !('willReadFrequently' in args[0]))) {
          args[0] = { ...args[0], willReadFrequently: true }
        }
        return originalGetContext.apply(this, [contextType, ...args])
      }
      window.__canvasContextPatched = true
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=8cb37912466817c1eb998c2e20cfe61f&plugin=AMap.Geocoder'
    
    script.onload = () => {
      // 等待 AMap 对象可用
      const checkAmap = () => {
        if (typeof window.AMap !== 'undefined') {
          resolve(window.AMap)
        } else {
          setTimeout(checkAmap, 50)
        }
      }
      checkAmap()
    }
    
    script.onerror = () => {
      window.__amapLoadingPromise = null
      reject(new Error('高德地图 API 加载失败'))
    }
    
    document.head.appendChild(script)
  })

  return window.__amapLoadingPromise
}

